<template>
  <div class="hp-base-panel-wrp">
    <div class="upgrade-pkgs hp-base-panel">
      <div class="top">
        <span class="title">精选方案({{ activities.length }})</span>
        <span v-if="activities.length > 3" @click="handleClickMore" class="more"
          >更多
          <img
            class="arrow-2"
            src="~images/platform/homepage/right-arrow-2.png"
            alt=""
        /></span>
      </div>
      <div :class="['pkgs-wrap', { 'only-one': activities.length === 1 }]">
        <updgradePkg
          v-for="a in activities"
          :key="a.id"
          :item="a"
          @showDetail="openDetail"
          @toOrder="toOrder"
        />
      </div>
    </div>
    <upgradePkgsPopup
      v-model="isShowUpgradePkgsPopup"
      :items="activities"
      @showDetail="openDetail"
    />
    <upgradePkgDetail
      :visible.sync="showDetail"
      :item="curPkgData"
      :tips="curPkgTips"
      :payParam="payParam"
      @toOrder="toOrder"
    />
  </div>
</template>

<script>
import updgradePkg from './upgradePkg.vue'
import upgradePkgDetail from './upgradePkgDetail.vue'
import upgradePkgsPopup from './upgradePkgsPopup.vue'
import { pkgDetailApi, preOrderInfo } from 'api/platform/homepage.js'
export default {
  components: {
    updgradePkg,
    upgradePkgsPopup,
    upgradePkgDetail
  },
  data() {
    return {
      isShowUpgradePkgsPopup: false,
      showDetail: false,
      curPkgData: {},
      payParam: {},
      curPkgTips: {},
      loading: null
    }
  },
  computed: {
    activities() {
      return this.$store.state.homepage.zxAdvancedInfo.activities || []
    }
  },
  methods: {
    openDetail(id) {
      this.loading = this.$loading()
      this.$trackEvent('newprofilepages_plan_detail', { package_id: id })
      pkgDetailApi({ id, teacher_id: this.$route.params.userId }).then(res => {
        const { code, data, message } = res
        if (code !== 0) {
          this.loading.close()
          return this.$toast(message)
        }
        const priceByType = this.groupBy(data.price, 'waytype')
        const typePrice =
          priceByType.video || priceByType.face || priceByType.voice
        this.curPkgData = data
        this.curPkgTips = this.getCurPkgTips(typePrice)
        this.preOrderInfo()
      })
    },
    preOrderInfo() {
      const { basic = {} } = this.curPkgData
      const { activity_type, id } = basic
      const { l, price } = this.curPkgTips
      const hasTeacher = !['theme', 'other'].includes(activity_type)
      const params = {
        to_user_id: hasTeacher ? this.$route.params.userId : 0,
        zx_num: l,
        waytype: price.waytype,
        activity_id: id,
        price_id: price.id
      }

      preOrderInfo(params)
        .then(res => {
          const { code, data, message } = res
          if (code !== 0) return this.$toast(message)
          this.payParam = data.pay_param
          this.showDetail = true
        })
        .finally(() => {
          this.loading.close()
        })
    },
    getCurPkgTips(list) {
      let l = 99,
        m = 0,
        price
      list.forEach(p => {
        const [l1, m1] = p.zx_num
        if (+l1 < +l) {
          l = +l1
          price = p
        }
        if (+m1 > m && +m1 >= l) m = +m1
      })
      if (!m) m = +l
      return {
        l,
        m,
        price,
        duration: price.duration,
        num: l + (l === m ? '次' : m < 99 ? `-${m}次` : '次起')
      }
    },
    groupBy(data, key) {
      const obj = {}
      data.forEach(d => {
        const k = d[key]
        const group = obj[k]
        if (!group) obj[k] = []
        obj[k].push(d)
      })
      return obj
    },
    handleClickMore() {
      this.$trackEvent('newprofilepages_plan_more', {})
      this.isShowUpgradePkgsPopup = true
    },
    toOrder(pkg) {
      !pkg.fromDetail &&
        this.$trackEvent('newprofilepages_plan', {
          package_id: pkg.id
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.upgrade-pkgs {
  padding-right: 0 !important;
}
.hp-base-panel-wrp {
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 30px;
    .title {
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 700;
      color: #21252d;
      line-height: 32px;
    }
    .more {
      display: flex;
      align-items: center;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #9da3ac;
      line-height: 28px;
    }
  }
  .pkgs-wrap {
    display: flex;
    padding-top: 40px;
    overflow: scroll;
    /deep/ .pkg:not(:first-child) {
      margin-left: 25px;
    }
    &:after {
      display: inline-block;
      content: '';
      padding: 0 13px;
    }
    &.only-one {
      &:after {
        display: none;
      }
      /deep/ .pkg {
        margin-left: 12px;
      }
    }
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
